import { getLocaleFromUrl } from "./locale-utils.js";
function extractCurrentRoute(path, locale) {
  const { pathname } = new URL(path, "https://not.used/");
  const urlLocale = getLocaleFromUrl(pathname);
  const parts = pathname.split("/") ?? [];
  const skip = locale && (pathname.includes(`/${locale.replace("-", "_")}`) || urlLocale) ? 3 : 2;
  return parts.slice(skip).join("/");
}
export {
  extractCurrentRoute
};
//# sourceMappingURL=extract-current-route.js.map
